export default __webpack_public_path__ + "static/media/hybrid-filled.79f30d94.svg";